<template>
  <div class="design_box_out">
      <p class="design_box_out_title"><i class="iconfont iconyou"></i>{{property.label}}</p>
      <div class="tool_company design_box">
        <div class="tool_company_top">
          <div class="tool_company_title">
            {{property.name?property.name:'公司名称'}}
          </div>
          <div class="contact_swiper_list">
            <em></em>
            <p>
              {{property.address?property.address:'公司地址'}}
            </p>
          </div>
          <div class="contact_swiper_list">
            <em></em>
            <p>
              {{property.mobile?property.mobile:'联系电话'}}
            </p>
          </div>
        </div>
        <div class="tool_company_bottom">
          <div class="tool_company_bottom_l tool_company_bottom_box">
            <i class="iconfont icondizhi"></i>
            立即定位
          </div>
          <div class="tool_company_bottom_r tool_company_bottom_box">
            <i class="iconfont icondianhua"></i>
            拨打电话
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        form: {}
      };
    }
  };
</script>



